export const RESTABLECER_PASSWORD = 200;
export const REGISTRAR_USUARIO = 400;
